import React from 'react';

import styled from 'styled-components';

import type { PositionRightDataType } from 'store/slices/globalSlice';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  margin-top: 4px;
`;

const PermissionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  vertical-align: middle;
`;

const PermissionsLabel = styled.span`
  display: flex;
  align-items: center;
  font-size: 10px;
  color: var(--text-secondary);
`;

const EmptyState = styled.span`
  font-size: 10px;
  color: var(--text-secondary);
`;

const PermissionTag = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--light-blue);
  color: var(--dark-blue);
  font-size: 10px;
  font-family: var(--font-regular);
`;

type Props = {
  position: PositionRightDataType | null;
};

const UserManagementPositionPermissions = ({ position }: Props) => {
  if (!position) {
    return null;
  }

  if (!position.permission_groups?.length) {
    return <EmptyState>No permissions linked to this position</EmptyState>;
  }

  return (
    <Container>
      <PermissionsList>
        <PermissionsLabel>Permissions</PermissionsLabel>
        {position.permission_groups.map((group) => (
          <PermissionTag key={group.id}>{group.name}</PermissionTag>
        ))}
      </PermissionsList>
    </Container>
  );
};

export default UserManagementPositionPermissions;
